import React from "react";
import testimonialPhoto from "../../../assets/portal/testimonial.jpg";
import { BG_PAGE, BRAND, NIGHT, ORANGE, CONTAINER } from "../tokens";

export default function Testimonial() {
  return (
    <section style={{ background: BG_PAGE, padding: "100px 0" }}>
      <div style={CONTAINER}>
        <div style={{ position: "relative", background: "linear-gradient(135deg, " + BRAND + " 0%, " + NIGHT + " 100%)", borderRadius: 22, padding: "60px 56px", color: "#FFFFFF", overflow: "hidden" }}>
          <div style={{ position: "absolute", top: -80, right: -80, width: 300, height: 300, borderRadius: "50%", background: "#E08A3C" }} />
          <div style={{ position: "absolute", bottom: -100, right: 80, width: 200, height: 200, borderRadius: "50%", background: "#6E7A3F" }} />
          <div style={{ position: "relative", display: "grid", gridTemplateColumns: "180px 1fr", gap: 44, alignItems: "center" }}>
            <div>
              <div style={{ width: 160, height: 160, borderRadius: "50%", padding: 5, background: ORANGE, overflow: "hidden" }}>
                <div style={{ borderRadius: "50%", overflow: "hidden", width: "100%", height: "100%" }}>
                  <img src={testimonialPhoto} alt="Customer testimonial" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                </div>
              </div>
              <div style={{ marginTop: 16, textAlign: "center" }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: "#FFFFFF" }}>A. Bennett</div>
                <div style={{ fontSize: 11, color: "rgba(255,255,255,0.6)", marginTop: 3, fontStyle: "italic" }}>Business owner (illustrative)</div>
              </div>
            </div>
            <div>
              <p style={{ fontSize: 22, color: "#FFFFFF", lineHeight: 1.45, fontWeight: 500, letterSpacing: "-0.01em", margin: "0 0 18px" }}>
                "The hours just show up. I look once, fix anything off, and pay. The team gets paid right, every time, with none of us doing the timesheet dance."
              </p>
              <div style={{ fontSize: 11.5, color: "rgba(255,255,255,0.5)", fontStyle: "italic", lineHeight: 1.5 }}>
                Illustrative quote, shown until a real customer testimonial is ready to publish with consent.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}